import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import supabase from '../lib/supabase';
import SafeIcon from '../common/SafeIcon';
import ImageWithFallback from './ImageWithFallback';
import * as FiIcons from 'react-icons/fi';

const { FiImage, FiVideo, FiArrowRight, FiPlay } = FiIcons;

const MediaWallPreview = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      const { data } = await supabase
        .from('gallery_items_aox1234')
        .select('id,title,type,url,date,tags,sort_order')
        .order('date', { ascending: false })
        .order('sort_order', { ascending: true })
        .limit(6);
      if (!cancelled) setItems(Array.isArray(data) ? data : []);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (!items.length) return null;

  return (
    <section className="bg-slate-950 py-16 text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="text-xs font-black uppercase tracking-[0.22em] text-blue-300">AOX Media</div>
            <h2 className="mt-2 text-3xl font-black md:text-4xl">Από το γήπεδο, την ομάδα και την ακαδημία</h2>
            <p className="mt-3 max-w-2xl text-slate-300">Οι τελευταίες φωτογραφίες και τα βίντεο του ΑΟ Χανιά.</p>
          </div>
          <Link to="/media" className="inline-flex items-center font-black text-blue-300 hover:text-white">Όλο το Media Wall <SafeIcon icon={FiArrowRight} className="ml-2 h-4 w-4" /></Link>
        </div>

        <div className="grid auto-rows-[180px] grid-cols-2 gap-3 md:auto-rows-[220px] md:grid-cols-4">
          {items.map((item, index) => {
            const featured = index === 0;
            return (
              <Link
                key={item.id}
                to="/media"
                className={`group relative overflow-hidden rounded-2xl bg-slate-800 ${featured ? 'col-span-2 row-span-2' : ''}`}
              >
                {item.type === 'video' ? (
                  <video src={item.url} muted preload="metadata" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                ) : (
                  <ImageWithFallback src={item.url} alt={item.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
                <div className="absolute left-3 top-3 inline-flex items-center rounded-full bg-black/45 px-2.5 py-1 text-[10px] font-black uppercase backdrop-blur-sm">
                  <SafeIcon icon={item.type === 'video' ? FiVideo : FiImage} className="mr-1.5 h-3.5 w-3.5" />
                  {item.type === 'video' ? 'Video' : 'Photo'}
                </div>
                {item.type === 'video' && <div className="absolute inset-0 flex items-center justify-center"><div className="flex h-11 w-11 items-center justify-center rounded-full bg-white/90 text-primary-700"><SafeIcon icon={FiPlay} className="ml-0.5 h-5 w-5" /></div></div>}
                <div className="absolute bottom-0 left-0 right-0 p-4"><div className={`${featured ? 'text-xl md:text-2xl' : 'text-sm md:text-base'} font-black leading-tight`}>{item.title}</div></div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MediaWallPreview;
